import styled from '@emotion/styled';

export const CaptionWrapper = styled.div`
	margin: 0 0 40px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
